import { Skeleton } from '~/components/ui/skeleton';

/**
 * Full-screen loading skeleton that mirrors the CopilotShell layout.
 * Used while the authenticated app shell is initializing.
 */
export function AppShellSkeleton() {
  return (
    <div className="flex h-dvh overflow-hidden">
      {/* Sidebar — mirrors CopilotShell aside (w-[72px]) */}
      <aside className="flex h-dvh w-18 shrink-0 flex-col overflow-hidden">
        {/* Tenant badge */}
        <div className="flex shrink-0 justify-center pt-5 pb-4">
          <Skeleton className="h-10 w-10 rounded-xl" />
        </div>

        {/* Nav icons */}
        <nav className="flex min-h-0 flex-1 flex-col items-center space-y-1 overflow-y-auto py-1">
          {/* Lily Agent */}
          <Skeleton className="h-10 w-10 rounded-xl" />

          {/* Separator */}
          <div className="w-10 py-1.5">
            <Skeleton className="h-px w-full" />
          </div>

          {/* Dashboard, Catalog Manager, Catalog Operations, Experiments, Taxonomy, Integrations */}
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} className="h-10 w-10 rounded-xl" />
          ))}

          {/* Separator */}
          <div className="w-10 py-1.5">
            <Skeleton className="h-px w-full" />
          </div>

          {/* History */}
          <Skeleton className="h-10 w-10 rounded-xl" />
        </nav>

        {/* User avatar */}
        <div className="flex shrink-0 justify-center py-1">
          <Skeleton className="h-9 w-9 rounded-full" />
        </div>
      </aside>

      {/* Content area */}
      <main className="bg-gradient-page flex-1 overflow-auto" />
    </div>
  );
}
